
export const bytesToString = (bytes: number) =>
{
    if(bytes / 1000 > 1000)
        return (bytes / 1000 / 1000).toFixed(2) + ' MB';
    else        
        return (bytes / 1000).toFixed(0) + ' KB';
}